import { CheckCircleFilled } from '@ant-design/icons';
import { Card, Col, Row, Upload } from 'antd';
import styled from 'styled-components';

export const Container = styled(Row)`
  margin: 12px;
`;

export const MapCol = styled(Col)`
  margin-left: 12px;
  height: calc(100vh - 170px);
`;

export const UploadDragger = styled(Upload.Dragger)<{ $isDisabled: boolean }>`
  padding: 0 20px;
  max-height: ${({ $isDisabled }) => ($isDisabled ? 0 : 200)}px;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0 : 1)};
  transition: opacity 0.3s, max-height 0.3s, border-color 0.3s !important;
`;

export const LeftCol = styled(Col)`
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 165px);
`;

export const MessageCard = styled(Card)`
  position: absolute;
  top: 76px;
  left: 55px;
  z-index: 400;
`;

export const CheckIcon = styled(CheckCircleFilled)`
  color: ${p => p.theme.success};
  margin-right: 9px;
`;
